/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import ConfigurationBlockCell from './ConfigurationBlockCell';
import ConfigurationBlockControls from './ConfigurationBlockControls';
import ConfigurationBlockCellProfilePopup from './partials/ConfigurationBlockCellProfilePopup';

const ConfigurationBlock = ({
	reference,
	code,
	buildingReference,
	amountGlassTypes,
	lastEditedUserId,
	lastEditedUserEmail,
	created,
	lastEdited,
	type,
	status,
	uploadedDocuments,
	isOrderPage,
	fullConfiguration,
	handleClickOnSort,
	handleSelected,
	isSelected,
}) => {
	const { t } = useTranslation('commonAppValues');
	const [selected, setSelected] = useState(isSelected);
	const lastHandledSelected = useRef(false);
	const isMounted = useRef(true);

	const keyDownHandler = e => {
		if (e.key === 'Enter' || e.key === ' ') {
			setSelected(!selected);
		}
	};

	useEffect(() => {
		if (isMounted.current && handleSelected && lastHandledSelected.current !== selected) {
			lastHandledSelected.current = selected;
			handleSelected(fullConfiguration, selected);
		}
		return () => {
			isMounted.current = false;
		};
	}, [fullConfiguration, handleSelected, selected]);

	const cls = classNames('configuration_block', { configuration_block__sel: selected });

	let hoverPopup = null;
	if (lastEditedUserId) {
		hoverPopup = ConfigurationBlockCellProfilePopup({ uid: lastEditedUserId });
	}

	return (
		<div
			className={cls}
			role={isOrderPage ? 'none' : 'button'}
			tabIndex={0}
			onClick={isOrderPage ? undefined : () => setSelected(!selected)}
			onKeyDown={isOrderPage ? undefined : keyDownHandler}
		>
			<div className="configuration_block__col">
				{!isOrderPage && (
					// Don't show checkbox on order preview
					<ConfigurationBlockCell
						type="checkbox"
						id={`selected-${type}-${status}-${code}`}
						value={code}
						checked={selected}
						onChange={e => setSelected(e.target.checked)}
					/>
				)}
			</div>
			<div className="configuration_block__col">
				<ConfigurationBlockCell
					type="configurationCode"
					title={t('configurationCodeLabel')}
					text={code}
				/>
			</div>
			<div className="configuration_block__col configuration_block__col--reference_state">
				<ConfigurationBlockCell
					title={t('cartPage:yourReferenceInputLabel')}
					text={reference}
					sortType="reference"
					onClickHandler={handleClickOnSort}
					ellipsized
				/>
			</div>
			<div className="configuration_block__col configuration_block__col--building_state">
				<ConfigurationBlockCell
					title={t('cartPage:buildingReferenceInputLabel')}
					text={buildingReference}
				/>
			</div>
			<div className="configuration_block__col configuration_block__col--types_state">
				<ConfigurationBlockCell title={t('types')} text={amountGlassTypes} />
			</div>
			<div className="configuration_block__col configuration_block__col--user">
				{lastEditedUserEmail && (
					<ConfigurationBlockCell
						title={t('user')}
						type="link"
						text={lastEditedUserEmail}
						link={`mailto:${lastEditedUserEmail}`}
						sortType="user"
						onClickHandler={handleClickOnSort}
						ellipsized
						hoverPopup={hoverPopup}
					/>
				)}
			</div>
			{!isOrderPage && (
				<>
					<div className="configuration_block__col configuration_block__col--created_state">
						<ConfigurationBlockCell title={t('created')} text={created} sortType="created" />
					</div>
					<div className="configuration_block__col configuration_block__col--edited_state">
						<ConfigurationBlockCell
							title={t('lastEdited')}
							sortType="lastEdited"
							text={lastEdited}
						/>
					</div>
					<div className="configuration_block__col configuration_block__col--controls_state">
						<ConfigurationBlockControls
							configurationCode={code}
							configurationType={type}
							configurationStatus={status}
							uploadedDocuments={uploadedDocuments}
							configuration={fullConfiguration}
						/>
					</div>
				</>
			)}
		</div>
	);
};

export default ConfigurationBlock;
